import http from './http';

export default {
    overview() {
        return http.get('/import/overview');
    },
    autoUpdateProductNumbers() {
        return http.post('/import/autoupdateproductnumbers');
    },
};
